import { create } from 'zustand';

interface LoginForm {
  email: string;
  password: string;
}

const initialForm: LoginForm = {
  email: '',
  password: '',
};

interface LoginStore {
  isSubmitting: boolean;
  form: LoginForm;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setForm: (form: Partial<LoginForm>) => void;
  reset: () => void;
}

export const useLoginStore = create<LoginStore>((set, get) => ({
  isSubmitting: false,
  form: initialForm,
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setForm: (updates) => set({ form: { ...get().form, ...updates } }),
  reset: () => set({ isSubmitting: false, form: initialForm }),
}));
